import { Route } from "react-router-dom";
import { Pages, Routes } from "@/constants/enums";
import AuthLayout from "@/pages/auth/AuthLayout";
import { PublicRoute } from "@/components/shared/guard-route";

import Login from "@/pages/auth/login";
import EnterOtp from "@/pages/auth/enter-otp";
import ForgotPassword from "@/pages/auth/forgot-password";
import ForgotPasswordSent from "@/pages/auth/forgot-password-sent";
import ResetPassword from "@/pages/auth/reset-password";
import SetPassword from "@/pages/auth/set-password";
import { RequiredPasswordChangeRoute } from "@/components/shared/required-password-change-route";
import Sso from "@/pages/auth/sso";

// Guest-only: signed-in users are bounced to the dashboard.
// Link/token flows (forgot-password, reset-password, set-password, sso) stay reachable while
// signed in — clicking an emailed link must never redirect to /admin.
export const authRoutes = (
  <Route path={`/${Routes.AUTH}`} element={<AuthLayout />}>
    <Route
      path={Pages.LOGIN}
      element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      }
    />
    <Route
      path={Pages.ENTER_OTP}
      element={
        <PublicRoute>
          <EnterOtp />
        </PublicRoute>
      }
    />
    <Route path={Pages.FORGOT_PASSWORD} element={<ForgotPassword />} />
    <Route
      path={`${Pages.FORGOT_PASSWORD}/sent`}
      element={<ForgotPasswordSent />}
    />
    <Route path={Pages.RESET_PASSWORD} element={<ResetPassword />} />
    <Route path={Pages.SET_PASSWORD} element={<SetPassword />} />
    <Route
      path={Pages.REQUIRED_PASSWORD_CHANGE}
      element={<RequiredPasswordChangeRoute />}
    />
    <Route path={Pages.SSO} element={<Sso />} />
  </Route>
);
